import React from 'react';
import { ApolloProvider, Query } from 'react-apollo';
import gql from 'graphql-tag';
import BCPGenerator from '../components/Succession/BCPGenerator';
import ErrorBoundary from '../components/ErrorBoundary';
import client from '../lib/apolloClient';

// GraphQL query to get BCP form data
const GET_BCP_DATA = gql`
  query GetBcpFormData {
    getCurrentUser {
      id
      bcp_form_datum {
        id
        user_id
        formData
        currentSection
        sectionCount
        completionPercentage
        status
        welcomeShown
        aiInsights {
          key_strengths
          identified_risks
          action_recommendations
          compliance_status
        }
      }
    }
  }
`;

// Simple loading spinner component
const SimpleLoadingSpinner = () => (
  <div className="flex justify-center items-center min-h-[200px]">
    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2" style={{ borderColor: 'var(--succession-primary, #5489B6)' }}></div>
  </div>
);

const BCPGeneratorContainer = ({ company, current_user, ...otherProps }) => {
  return (
    <ApolloProvider client={client}>
      <ErrorBoundary>
        <Query query={GET_BCP_DATA}>
          {({ loading, error, data }) => {
            if (loading) return <SimpleLoadingSpinner />;
            if (error) return <div>Error loading BCP data: {error.message}</div>;
            
            const bcpData = data?.getCurrentUser?.bcp_form_datum || null;
            
            return (
              <BCPGenerator 
                bcpData={bcpData}
                company={company}
                current_user={current_user}
                {...otherProps}
              />
            );
          }}
        </Query>
      </ErrorBoundary>
    </ApolloProvider>
  );
};

export default BCPGeneratorContainer; 